import { useRef } from "react";

import useSound from "use-sound";

import {
  Player,
  BigPlayButton,
  ControlBar,
  ReplayControl,
  ForwardControl,
  VolumeMenuButton,
  FullscreenToggle,
} from "video-react";

import { useNavigate } from "react-router-dom";
import { useGame } from "../../contexts/GameProvider";

import clickDownSfx from "../../sfx/bloop-1.mp3";
import clickOnSfx from "../../sfx/bloop-2.mp3";

import "./Debrief.css";
import RedFlag from "../Icon/RedFlag/RedFlag";

export default function Debrief() {
  const feedback = useRef(null);

  const { gameState, gameDispatch, resetGame } = useGame();

  const navigate = useNavigate();

  const [clickDown] = useSound(clickDownSfx, { volume: 0.75 });
  const [clickOn] = useSound(clickOnSfx, { volume: 0.75 });

  return (
    <div className="debrief">
      <div className="debrief-header">
        <h1>
          You found <RedFlag size="1em" />
          {gameState.subtitles.filter((el) => el.redFlag && el.flagged).length}/
          {gameState.subtitles.filter((el) => el.redFlag).length} Red Flags
        </h1>
        <p>
          Watch the video below to find out what happened to our Hedge-Fund
          Hoaxer…
        </p>
      </div>
      <div className="video-wrapper">
        <Player
          ref={feedback}
          playsInline
          poster="/assets/poster.png"
          src="/assets/part2.mp4"
        >
          <BigPlayButton position="center" />
          <ControlBar autoHide={false}>
            <ReplayControl seconds={10} order={2.2} />
            <ForwardControl seconds={10} order={2.3} />
            <VolumeMenuButton order={7} vertical />
            <FullscreenToggle disabled />
          </ControlBar>
        </Player>
      </div>
      <div className="controls">
        <button
          className="btn btn-confirm"
          onMouseDown={clickDown}
          onMouseUp={() => {
            gameDispatch(resetGame());

            clickOn();

            navigate("/");
          }}
        >
          Start again
        </button>
      </div>
    </div>
  );
}
